import type { OrchestrationThread, OrchestrationThreadHistoryPage } from "@afar-research/contracts";

function prependUnique<T>(
  older: ReadonlyArray<T>,
  current: ReadonlyArray<T>,
  key: (value: T) => string,
): ReadonlyArray<T> {
  const values = new Map(older.map((value) => [key(value), value]));
  for (const value of current) values.set(key(value), value);
  return [...values.values()];
}

/** Merge an immutable older page underneath the currently live thread window. */
export function mergeOlderThreadHistoryPage<TThread extends OrchestrationThread>(
  current: TThread,
  older: OrchestrationThreadHistoryPage,
): TThread {
  if (current.id !== older.threadId) return current;

  return {
    ...current,
    messages: prependUnique(older.messages, current.messages, ({ id }) => id),
    proposedPlans: prependUnique(older.proposedPlans, current.proposedPlans, ({ id }) => id),
    activities: prependUnique(older.activities, current.activities, ({ id }) => id),
    checkpoints: prependUnique(
      older.checkpoints,
      current.checkpoints,
      ({ turnId, checkpointTurnCount }) => `${turnId}\u0000${checkpointTurnCount}`,
    ),
  } as TThread;
}
